import React, { Fragment, Component } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CadeDomainItem from './CadeDomainItem';
import authService from '../../services/AuthService';
import api, { apiErrorHandler, apiResponseHandler } from '../../services/AxiosService';
import { alertPopup, apiErrorPopup } from '../../helpers/MessagePopup';
class CadeDomainItems extends Component {

    constructor(props) {
        super(props);

        this.state = {
        }
    }

    submitHandler = () => {

        // Indicate the assessment has been completed
        let url = "/assessment/" + this.props.assessmentId + "/state";
            
        api.post(url,
            {
                AssessmentId: this.state.assessmentId,
                UserId: authService.authenticatedUserId,
                UserName: authService.authenticatedUserName,
                UserType: authService.userType,
                State: "completed"
            },
            {
                headers: {
                    Authorization: 'Bearer ' + authService.token
                }
            })
            .then((response) => {
                if (response.status == 200) {
                    alertPopup('success', response.data.message);
                }
                else {
                    apiErrorPopup(apiResponseHandler(response));
                };
            })
            .catch((error) => {
                apiErrorPopup(apiErrorHandler(error));
            });
    }

    render() {
        // Build the table's rows.  
        let rater1Name = null;
        let rater2Name = null;
        let rater3Name = null;
        let domainItems = this.props.items.map((item) => {
            let textClass = null;
            rater1Name = item.rater1Id;
            rater2Name = item.rater2Id;
            rater3Name = item.rater3Id;
            return (
                <CadeDomainItem
                    key={item.itemDefId}
                    assessmentItemId={item.assessmentItemId}
                    itemDefId={item.itemDefId}
                    area={item.assessmentArea}
                    text={item.text}
                    textClass={textClass}
                    desc={item.description}
                    cadeAiUserResponse={item.cadeAiUserResponse}       
                    caregiverResponse={item.caregiverResponse}
                    rater3Id={item.rater3Id}
                    partnerProviderResponse={item.partnerProviderResponse}
                    partnerProviderName={item.partnerProviderName}
                    rater1Response={item.rater1Response}
                    rater1Id={item.rater1Id}
                    rater2Response={item.rater2Response}
                    rater2Id={item.rater2Id}
                    isCaregiver={this.props.isCaregiver}
                    isRater1={this.props.isRater1}
                    isRater2={this.props.isRater2}
                    isRater3={this.props.isRater3}
                    isPartnerProvider={this.props.isPartnerProvider}
                    resources={item.resources}
                    readonly={this.props.readonly}
                    resClickHandler={this.props.resClickHandler}
                    changeHandler={this.props.changeHandler}
                />
            );
        });

        let isCaregiverOrRater = this.props.isCaregiver || this.props.isRater1 || this.props.isRater2 || this.props.isRater3;
        let numUnanswered = this.props.numUnanswered();

        let prevDisabled = (this.props.cadeDomain == "Communicating") ? "disabled" : null;
        let nextDisabled = (this.props.cadeDomain == "Behaving") ? "disabled" : null;
        let submitDisabled = (numUnanswered != 0) ? "disabled" : null;
        let submitText = (numUnanswered == 0) ? "Submit Responses" : (numUnanswered == 1) ? numUnanswered + " Item Left!" : numUnanswered + " Items Left!";
        let showSubmitAsButton = (numUnanswered == 0);

        // Remove the __n from rater names
        rater1Name = (rater1Name != null) ? rater1Name.substring(0, rater1Name.length - 3) : null;
        rater2Name = (rater2Name != null) ? rater2Name.substring(0, rater2Name.length - 3) : null;
        rater3Name = (rater3Name != null) ? rater3Name.substring(0, rater3Name.length - 3) : null;

        return (
            <Form>
                <Table striped bordered responsive onMouseLeave={this.props.saveHandler}>
                    <thead>
                        <tr>
                            <th width ={130}>Area</th>
                            <th class="tour_inputItem">Item</th>
                            <th class="tour_inputConcern" width={145}>Concern</th>
                            
                            {!isCaregiverOrRater && !this.props.isPartnerProvider &&
                                <th width={145}>CADE User</th>
                            }

                            {!isCaregiverOrRater &&
                                <Fragment className="tour_inputRaters">
                                <th width={145}>{rater1Name}</th>
                                <th width={145}>{rater2Name}</th>
                                <th width={145}>{rater3Name}</th>
                                </Fragment>
                            }

                            <th class="tour_inputResources" width={100}>Tell Me More!</th>
                        </tr>
                    </thead>
                    <tbody>
                        {domainItems}
                    </tbody>
                </Table>

                <Fragment>
                    {authService.authenticatedUserRestrictedDomains == null &&
                        <Row>
                            <Col sm={4}>
                                <Button style={{ marginBottom: "20px" }} variant="secondary" onClick={this.props.prevDomain} disabled={prevDisabled}>Previous Input Section</Button>
                                <Button style={{ marginLeft: "20px", marginBottom: "20px" }} variant="primary" onClick={this.props.nextDomain} disabled={nextDisabled}>Next Input Section</Button>
                            </Col>
                        <Col sm={8}>
                            {showSubmitAsButton &&
                                <Button style={{ marginBottom: "20px" }} variant="primary" onClick={this.submitHandler} disabled={submitDisabled}>{submitText}</Button>
                            }
                            {!showSubmitAsButton &&
                                <p className="cadeInput_numUnanswered">{submitText}</p>
                            }
                            </Col>
                        </Row>
                    }
  
                </Fragment>

            </Form>
        );
    }
}

export default CadeDomainItems;


// WEBPACK FOOTER //
// ./src/components/CadeComponent/CadeDomainItems.js